// src/utils/authToken.jsx
import { jwtDecode } from "jwt-decode"

/**
 * Decode JWT and return expiry (seconds since epoch).
 * Returns 0 if token is missing or invalid.
 */
export function getTokenExpiry(token) {
  if (!token) return 0
  try {
    const decoded = jwtDecode(token)
    return typeof decoded?.exp === "number" ? decoded.exp : 0
  } catch {
    return 0
  }
}

/**
 * Check if a JWT is expired.
 * @param {string} token
 * @param {number} [skewSeconds=60]
 * @returns {boolean}
 */
export function isTokenExpired(token, skewSeconds = 60) {
  if (!token) return true
  const exp = getTokenExpiry(token)
  const now = Math.floor(Date.now() / 1000)
  return exp <= now + skewSeconds
}
